import { EditableAccessRule, ValidationError } from "../../models";

export function getAllValidationErrors(
  ruleSets: EditableAccessRule[][],
): ValidationError[] {
  return ruleSets.flat().flatMap((rule) => rule.validate());
}

export function shouldShowSubmitValidationForRow(
  submitCount: number,
  hasChangesSinceSubmit: boolean,
  rowIsEmpty: boolean,
): boolean {
  const submitOccurred = submitCount > 0;

  return submitOccurred && (!hasChangesSinceSubmit || !rowIsEmpty);
}
